import { render, staticRenderFns } from "./AGCEditGroupPassword.vue?vue&type=template&id=2788b5ec&scoped=true&"
import script from "./AGCEditGroupPassword.vue?vue&type=script&lang=js&"
export * from "./AGCEditGroupPassword.vue?vue&type=script&lang=js&"
import style0 from "./AGCEditGroupPassword.vue?vue&type=style&index=0&id=2788b5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788b5ec",
  null
  
)

export default component.exports